/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetCouriersReport200ResponseValue,
  GetLastOpenShiftMovements200Response,
  GetLastOpenShiftMovements200ResponseMovementsInner,
  GetLastShift200Response,
  GetLocationShiftsQuantity200Response,
  GetOpenMethodsWithCurrentAmount200ResponseInner,
  GetZReport200Response,
} from '../models/index';
import {
    GetCouriersReport200ResponseValueFromJSON,
    GetCouriersReport200ResponseValueToJSON,
    GetLastOpenShiftMovements200ResponseFromJSON,
    GetLastOpenShiftMovements200ResponseToJSON,
    GetLastOpenShiftMovements200ResponseMovementsInnerFromJSON,
    GetLastOpenShiftMovements200ResponseMovementsInnerToJSON,
    GetLastShift200ResponseFromJSON,
    GetLastShift200ResponseToJSON,
    GetLocationShiftsQuantity200ResponseFromJSON,
    GetLocationShiftsQuantity200ResponseToJSON,
    GetOpenMethodsWithCurrentAmount200ResponseInnerFromJSON,
    GetOpenMethodsWithCurrentAmount200ResponseInnerToJSON,
    GetZReport200ResponseFromJSON,
    GetZReport200ResponseToJSON,
} from '../models/index';

export interface GetLastOpenShiftMovementsRequest {
    tillId: string;
}

export interface GetLastShiftRequest {
    tillId: string;
}

export interface GetLastTillShiftMovementsRequest {
    tillId: string;
}

export interface GetLocationShiftsQuantityRequest {
    startDate: string;
    endDate: string;
}

export interface GetOpenMethodsWithCurrentAmountRequest {
    tillId: string;
}

export interface GetZReportRequest {
    startDate?: string;
    endDate?: string;
}

export interface ResetCourierShiftRequest {
    courierId: string;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     */
    async getCouriersReportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: GetCouriersReport200ResponseValue; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/couriers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, GetCouriersReport200ResponseValueFromJSON));
    }

    /**
     */
    async getCouriersReport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: GetCouriersReport200ResponseValue; }> {
        const response = await this.getCouriersReportRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getLastOpenShiftMovementsRaw(requestParameters: GetLastOpenShiftMovementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastOpenShiftMovements200Response>> {
        if (requestParameters['tillId'] == null) {
            throw new runtime.RequiredError(
                'tillId',
                'Required parameter "tillId" was null or undefined when calling getLastOpenShiftMovements().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tillId'] != null) {
            queryParameters['tillId'] = requestParameters['tillId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/open-shift-movements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastOpenShiftMovements200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLastOpenShiftMovements(requestParameters: GetLastOpenShiftMovementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastOpenShiftMovements200Response> {
        const response = await this.getLastOpenShiftMovementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLastShiftRaw(requestParameters: GetLastShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLastShift200Response>> {
        if (requestParameters['tillId'] == null) {
            throw new runtime.RequiredError(
                'tillId',
                'Required parameter "tillId" was null or undefined when calling getLastShift().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tillId'] != null) {
            queryParameters['tillId'] = requestParameters['tillId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/last-shift`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLastShift200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLastShift(requestParameters: GetLastShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLastShift200Response> {
        const response = await this.getLastShiftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLastTillShiftMovementsRaw(requestParameters: GetLastTillShiftMovementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetLastOpenShiftMovements200ResponseMovementsInner>>> {
        if (requestParameters['tillId'] == null) {
            throw new runtime.RequiredError(
                'tillId',
                'Required parameter "tillId" was null or undefined when calling getLastTillShiftMovements().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tillId'] != null) {
            queryParameters['tillId'] = requestParameters['tillId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/last-till-shift-movements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLastOpenShiftMovements200ResponseMovementsInnerFromJSON));
    }

    /**
     */
    async getLastTillShiftMovements(requestParameters: GetLastTillShiftMovementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetLastOpenShiftMovements200ResponseMovementsInner>> {
        const response = await this.getLastTillShiftMovementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationShiftsQuantityRaw(requestParameters: GetLocationShiftsQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLocationShiftsQuantity200Response>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getLocationShiftsQuantity().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getLocationShiftsQuantity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/shifts/location-shifts-quantity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLocationShiftsQuantity200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLocationShiftsQuantity(requestParameters: GetLocationShiftsQuantityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLocationShiftsQuantity200Response> {
        const response = await this.getLocationShiftsQuantityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOpenMethodsWithCurrentAmountRaw(requestParameters: GetOpenMethodsWithCurrentAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetOpenMethodsWithCurrentAmount200ResponseInner>>> {
        if (requestParameters['tillId'] == null) {
            throw new runtime.RequiredError(
                'tillId',
                'Required parameter "tillId" was null or undefined when calling getOpenMethodsWithCurrentAmount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tillId'] != null) {
            queryParameters['tillId'] = requestParameters['tillId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/open-methods-with-current-amount`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetOpenMethodsWithCurrentAmount200ResponseInnerFromJSON));
    }

    /**
     */
    async getOpenMethodsWithCurrentAmount(requestParameters: GetOpenMethodsWithCurrentAmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetOpenMethodsWithCurrentAmount200ResponseInner>> {
        const response = await this.getOpenMethodsWithCurrentAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getXReportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetZReport200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/x`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetZReport200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getXReport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetZReport200Response> {
        const response = await this.getXReportRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getZReportRaw(requestParameters: GetZReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetZReport200Response>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/z`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetZReport200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getZReport(requestParameters: GetZReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetZReport200Response> {
        const response = await this.getZReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async resetCourierShiftRaw(requestParameters: ResetCourierShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['courierId'] == null) {
            throw new runtime.RequiredError(
                'courierId',
                'Required parameter "courierId" was null or undefined when calling resetCourierShift().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reports/couriers/{courierId}/reset`.replace(`{${"courierId"}}`, encodeURIComponent(String(requestParameters['courierId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async resetCourierShift(requestParameters: ResetCourierShiftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resetCourierShiftRaw(requestParameters, initOverrides);
    }

}
